import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OmsServiceService } from '../services/oms-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment-mini-ts';
import { GeocodeService } from '../services/geocode.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.scss']
})
export class LeadsComponent implements OnInit {
  @ViewChild('tenantSelect') tenantSelect: NgSelectComponent;
  constructor(private api: OmsServiceService, private modalService: NgbModal, private SpinnerService: NgxSpinnerService,
    private _geocodeService: GeocodeService, private fb: FormBuilder, private toastr: ToastrService) { }

  OrgList: any = []
  maxDate = new Date();
  bsRangeValue: Date[];
  modalRef: any;
  searchType = 'mobile';
  MobileNumber: any;
  currentDate = new Date();
  selectedTenant: any = []
  tenantsList: any = []
  organizationsOfTenants: any = []
  selectedOrg: any = []
  tenantsOrgList: any = []
  selectedTenantCode: any
  selectedOrgCode: any=''
  searchTenantCode:any;
  searchOrgCode:any;
  serchBy='mobile';
  mrnValue:any;
  mobileNOValue:any;
  leadStaus='';
  userRegistration_Form!: FormGroup;
  addressRegForm!: FormGroup;
  mobileNO_Form!:FormGroup;
  ledsContainer = ''
  ordersContainer=''
  totalRecords:any;
  page = 1;
  pageSize = 20;
  skipRecoreds=0;
  pickUpLocation: any;
  leadObj: any = {};
  coordinatesLat: any;
  coordinatesLong: any;
  locationData: any;
  accessToken: any;
  customerDetails: any = []
  addressDetails: any = []
  parentMrnDetails: any = {}
  leadsList: any=[]
  combinedPlanNames:any
  selectedCustomerDeatils:any={}
  selectedAddressDetails:any={}
  leadsCraetion_Form!:FormGroup
  discharge_form!:FormGroup
  selectedOrgName:any;
  dynamicBusiness:any=[]
  selectedBusiness:any=[]
  reportuploadedFile:any=[]
  documentId:any;
  selectedLeadDetails:any={}
  ListTagsWithPackages:any=[]
  listOfPackages:any=[]
  selectedPackages:any=[]
  selectedPackagesForOrders:any=[]
  selectedDetailsForOrders:any
  isNewCustomer:number=0
  ordersErrorMessages=''

  ngOnInit(): void {
    // this.bsRangeValue = [this.currentDate, this.maxDate];
    this.currentDate.setDate(new Date().getDate()-15);
    this.maxDate.setDate(new Date().getDate() + 1);
    this.bsRangeValue = [this.currentDate, this.maxDate];

    this.mobileNO_Form=this.fb.group({
      mobile:['', Validators.compose([Validators.required,]),]
    })
    this.discharge_form=this.fb.group({
      file:['', Validators.compose([Validators.required,]),],
    })
    this.leadsCraetion_Form=this.fb.group({
      serviceName:[''],
      businessName:['', Validators.compose([Validators.required,]),],
      dischargeSummary:[''],
      file:[''],
      remarks:['']
    })

    this.addressRegForm = this.fb.group({
      //addr:['', Validators.compose([Validators.required,]),],
      bflat: ['', Validators.compose([Validators.required,]),],
      street: ['', Validators.compose([Validators.required,])],
      land: [''],
      city: ['', Validators.compose([Validators.required,]),],
      pincode: ['', Validators.compose([Validators.required,]),],
      state: ['', Validators.compose([Validators.required,]),],
      country: ['', Validators.compose([Validators.required,]),],
      addrType: ['', Validators.compose([Validators.required,]),],
      addrValue: [''],

    })

    this.userRegistration_Form = this.fb.group({
      firstName: ['', Validators.compose([
        Validators.required,
        // ValidationUtil.onlyAlphabetsValidator('onlyAlphabets')
      ]),
      ],
      lastName: ['', Validators.compose([
        // ValidationUtil.onlyAlphabetsValidator('onlyAlphabets')
      ])],
      dob: ['', Validators.compose([Validators.required])],
      gender: ['', Validators.compose([Validators.required,]),],
      mobileNumber: ['',
        Validators.compose([
          Validators.required,
          // ValidationUtil.phoneNumberValidator,
        ]),
      ],
      email: ['', Validators.compose([
        // ValidationUtil.emailValidator,
      ]),
      ],
    })

    if(localStorage.getItem('userDataRoleBased') != undefined && JSON.parse(localStorage.getItem('userDataRoleBased')).tenant != undefined && JSON.parse(localStorage.getItem('userDataRoleBased')).tenant =='1000267'){
      this.tenantsOrgList = [{
                "organizationCode": "100364",
              "organizationName": "Healthy Recovery",
              "tenantCode": "1000267",
      }]
      this.searchTenantCode="1000267"
      this.searchOrgCode="100364"

    }else{
      this.getTenantOrgLists()
    }

    this.getLeadsList()
    this.getBusinessData()
  }


  get f() { return this.addressRegForm.controls }
  getTenatList() {
    this.tenantsList = [];
    let payload = {
      "action": 'OMS/api/operation.php/v1/get/list/tenants',
      "type": "post"
    }
    this.api.getTenantList(payload).subscribe((res: any) => {
      if (res.status === 1) {
        this.tenantsList = res["data"]
      }
    })
  }

  getBusinessData() {
    let businesses = {};
        businesses["action"] = 'OMS/api/operation.php/v1/fetchBusinesses',
        businesses["type"] = 'post';
        this.api.fetchBusiness(businesses).subscribe(
        (res:any) => {
             this.dynamicBusiness = res['data'];
        })
             
  }
  getTenantOrgLists() {
    this.api.getTenantOrgList().subscribe((res: any) => {
      if (res.status == 'SUCCESS') {
        this.tenantsOrgList = res.dataObject
      }
    })
  }
  onTenantOrgSelection(event: any) {
    let selectedData = event
    if (selectedData != undefined && selectedData != null && selectedData != '') {
      this.selectedTenantCode = selectedData.tenantCode
      this.selectedOrgCode = selectedData.organizationCode
      this.selectedOrgName=selectedData.organizationName
    } else {
      this.selectedTenantCode = ''
      this.selectedOrgCode = ''
    }
  }
  onTenantOrgSearch(event: any) {
    let selectedData = event
    if (selectedData != undefined && selectedData != null && selectedData != '') {
      this.searchTenantCode = selectedData.tenantCode
      this.searchOrgCode = selectedData.organizationCode
      // this.selectedOrgName=selectedData.organizationName
    } else {
      this.searchTenantCode ='';
      this.searchOrgCode  ='';
    }
  }
  getTenantOrgList(data) {
    const requestBody = {}
    requestBody['tenantCode'] = `${data.join(',')}`;
    requestBody['action'] = 'OMS/api/operation.php/v1/fetch/org/list/tenantcodes';
    requestBody['type'] = 'post';
    this.api.getTenatOrganisationList(requestBody).subscribe((res: any) => {
      if (res.status == 1) {
        this.organizationsOfTenants = res.data.dataObject

      }
    })
  }

  onOrgSelect(event: any) {
    let array = []
    event.forEach((res: any) => {
      array.push(res.organizationCode)
    })
    this.selectedOrg = array
  }

  onBusinessSelect(event: any) {
    console.log(event)
    let array=[]
    event.forEach((res: any) => {
      array.push(res.ID)
    })
    this.selectedBusiness=array
  }

  onTenantSelect(event: any) {
    let array = []
    event.forEach((res: any) => {
      array.push(res.tenantCode)
    })
    console.log(event)
    this.selectedTenant = array
    this.getTenantOrgList(this.selectedTenant)
  }

  resetTeantFilters() {
    // this.searchForm.patchValue({ 'selectedTenant': [], 'selectedOrg': [] });
    this.organizationsOfTenants = []
  }

  onValueChange(value: Date): void {
    var data = value;
    this.currentDate = data[0]
    this.maxDate = data[1]
    console.log(`data`, this.currentDate);
  }
  addAddressMethod(){
    this.ordersContainer='addAddress'
  }
  openledsToOrdersModal(ledsToOrdersModal:TemplateRef<any>,data:any){
    console.log(data)
    this.selectedDetailsForOrders=data
    this.selectedLeadDetails=data
    this.selectedPackagesForOrders=data.plans
    this.selectedTenantCode=data.tenantCode
    this.selectedOrgCode=data.orgCode
    this.ordersContainer='orderDetails'
    this.searchCustomer(this.selectedLeadDetails.customerMobile);
    this.modalRef = this.modalService.open(ledsToOrdersModal, { windowClass: 'commonStyleModals modalWidth90' });

  }
  openUploadDischargeSummaryModal(uploadDischargeSummary:TemplateRef<any>,data:any){
    this.selectedLeadDetails=data
    
    this.modalRef = this.modalService.open(uploadDischargeSummary, { windowClass: 'commonStyleModals modalWidth500px' });

  }
  openShowLeadsHistoryModal(showLeadsHistoryModal:TemplateRef<any>,data:any){
    console.log(data)
    this.selectedDetailsForOrders=data
    this.selectedLeadDetails=data
    this.selectedPackagesForOrders=data.plans
    this.selectedTenantCode=data.tenantCode
    this.selectedOrgCode=data.orgCode
    this.ordersContainer='orderDetails'
    this.searchCustomer(this.selectedLeadDetails.customerMobile);
    this.modalRef = this.modalService.open(showLeadsHistoryModal, { windowClass: 'commonStyleModals modalWidth90' });

  }
  openLedsModal(addLeadsModal: TemplateRef<any>) {
    this.addressDetails = []
    this.customerDetails = []
    this.selectedBusiness=[]
    this.MobileNumber = ''
    this.mobileNO_Form.reset()
    this.ledsContainer = ''
    this.documentId=''
    this.parentMrnDetails = {}
    this.userRegistration_Form.reset()
    this.addressRegForm.reset()
    this.modalRef = this.modalService.open(addLeadsModal, { windowClass: 'commonStyleModals modalWidth90' });
  }

  openPlanAddModal(addPlansModal: TemplateRef<any>,leadObj:any) {
    this.selectedLeadDetails=leadObj
    this.getTagsWithPackages()
    this.selectedPackages=[]
    console.log(this.selectedLeadDetails)
    this.modalRef = this.modalService.open(addPlansModal, { windowClass: 'commonStyleModals modalWidth500px' });
  }

  searchCustomer(mobileNumber:any) {
    if (mobileNumber != "" && mobileNumber != null && mobileNumber != undefined) {
      let payload = {
        "mobile": mobileNumber,
        "tenant_code": this.selectedTenantCode,
        "org_code": this.selectedOrgCode
      }
      this.SpinnerService.show()
      this.api.searchCustomers(payload).subscribe((res: any) => {
        this.SpinnerService.hide()
        if (res.status == 'SUCCESS') {
          let mrn: any
          this.accessToken = res.cutomer_dependents.AccessToken
          console.log(res)
          // this.parentMrnDetails = res.cutomer_dependents.DependantDetails[0]
          res.cutomer_dependents.DependantDetails.forEach((data: any) => {
            if (data.is_dependent == 0) {
              this.parentMrnDetails = data
              mrn = data.customerMRNID
              // mrn = res.cutomer_dependents.DependantDetails[0].customerMRNID
              this.getCustomerDetails(mrn)
            }
          })
        } else {
          // this.toastr.error(res.reason);
          this.ledsContainer = 'Registration'
          this.userRegistration_Form.patchValue({
            mobileNumber: this.mobileNO_Form.value.mobile
          })
        }
      })
    }else{
        this.toastr.error("please pass mobile number");
    }
  }

  customerRegistration() {

    let payload = {
      "firstName": this.userRegistration_Form.value.firstName,
      "lastName": this.userRegistration_Form.value.lastName,
      "email": this.userRegistration_Form.value.email,
      "dob": moment(this.userRegistration_Form.value.dob).format('DD-MM-YYYY'),
      "gender": this.userRegistration_Form.value.gender,
      "mobile": this.userRegistration_Form.value.mobileNumber,
      "consent": 1,
      "password": "",
      "createdBy": "admin",
      "languageId": "1",
      "modeId": "2",
      "colorPalleteId": "1",
      "whatsappComm": 1,
      "organizationCode": this.selectedOrgCode,
      "tenantCode": this.selectedTenantCode,
      "sourceType": "CP"
    }
    this.SpinnerService.show()
    this.api.customerRegistration(payload).subscribe((res: any) => {
      this.SpinnerService.hide()
      if (res.status == 'SUCCESS') {
        this.SpinnerService.hide()
        this.userRegistration_Form.reset()
        this.accessToken = res.customer_registration.accessToken
        let mrn = res.customer_registration.mrn
        this.selectedCustomerDeatils=res.customer_registration
        this.getCustomerDetails(mrn)
        this.toastr.success()
        this.toastr.success(res.reason);
        this.isNewCustomer=1
      }else{
        this.toastr.error(res.reason);
      }
    })

  }

  getCustomerDetails(mrn: any) {
    let payload = {
      "mrn": mrn,
      "organizationCode": this.selectedOrgCode,
      "tenantCode": this.selectedTenantCode
    }
    this.SpinnerService.show()
    this.api.getCustomerDetails(payload).subscribe((res: any) => {
      this.SpinnerService.hide()
      if (res) {
        res.members.forEach((data:any)=>{
            if(this.parentMrnDetails.customerMRNID == data.customerMRNID){
              this.selectedCustomerDeatils=data
            }
        })
        if(res.address.length){
          res.address.forEach((data:any)=>{
            if(data.isDefaultAddress ==1){
              this.selectedAddressDetails=data
            }
          })
        }
      
        this.customerDetails = res.members
        this.addressDetails = res.address
        this.ledsContainer = 'creatLeads'
      }
    })
  }

  onItemClicked(location: any) {
    // this.locationSelectBoolean = true;
    this.pickUpLocation = location.formatted_address;
    this.leadObj.pickUpLocation = location.formatted_address;
    this.coordinatesLat = location.latitude;
    this.coordinatesLong = location.longitude;
    this.geoSuccess(location, "add");
  }

  geoSuccess(location: any, type: any) {
    console.log(location)
    this._geocodeService
      .geocode(location.latitude, location.longitude)
      .subscribe((response: any) => {
        console.log("this.locationData===", this.locationData)
        this.locationData = response;
        console.log("location data is===>", this.locationData)
        this.addressRegForm.patchValue({
          pincode: this.locationData.zip,
          state: this.locationData.state,
          city: this.locationData.city,
          country: this.locationData.country,
          street: this.locationData.area,
        })
      });



  }

  addNumber() {
    this.ledsContainer = 'Registration'
  }

  addAddress() {
    let payload = {
      "addressNameVal": this.addressRegForm.value.addrType == 'Other' ? 'Other' : '',
      "district": "",
      "country": this.addressRegForm.value.country,
      "area": this.addressRegForm.value.street,
      "city": this.addressRegForm.value.city,
      "zipcode": this.addressRegForm.value.pincode,
      "state": this.addressRegForm.value.state,
      "landmark": this.addressRegForm.value.land,
      "latitude": this.coordinatesLat,
      "longitude": this.coordinatesLong,
      "address": this.addressRegForm.value.bflat,
      "customerMRNID": this.parentMrnDetails.customerMRNID,
      "CH_Unique_ID": this.parentMrnDetails.customerMRNID,
      "isAdd": 1,
      "isDefault": 0,
      "isDefaultAddress": 0,
      "addressType": this.addressRegForm.value.addrType == 'Other' ? this.addressRegForm.value.addrValue : this.addressRegForm.value.addrType,
      "createdBy": this.parentMrnDetails.customerMRNID,
      "modifiedBy": this.parentMrnDetails.customerMRNID,
      "enabled": 1,
      "mandal": "",
      "customerAddrID": 0,
      "authMrn": this.parentMrnDetails.customerMRNID,
      "sourceType": "CP",
      "accessToken": this.accessToken,
      "organizationCode": this.selectedOrgCode,
      "tenantCode": this.selectedTenantCode
    }
    this.SpinnerService.show()
    this.api.addAddress(payload).subscribe((res: any) => {
      this.SpinnerService.hide()
      if (res.status == 'SUCCESS') {
        this.addressRegForm.reset()
        // this.ledsContainer = 'creatLeads'
        this.ordersContainer = 'orderDetails'
        this.ordersErrorMessages=''
        this.getCustomerDetails(this.parentMrnDetails.customerMRNID)
        this.toastr.success(res.reason)

      }else{
        this.toastr.error(res.reason)
      }
    })
  }

  selectnumber(data:any){
    this.selectedCustomerDeatils=data
    console.log(this.selectedCustomerDeatils)
  }
  selectAddress(data:any){
    this.selectedAddressDetails=data
    console.log(this.selectedAddressDetails)
  }
  pageChange(page){
    this.page=page;
    this.skipRecoreds= this.pageSize * (this.page - 1);
    this.getLeadsList()
  }
  getLeadsList() {
  
    let payload = {
      "action": "OMS/api/v4/lead/list",
      "type": "post",
      "actionById": "SDM",
      "actionByName": "admin",
      "channelCode": "1",
      "noOfRecords": this.pageSize,
      "skip": this.skipRecoreds,
      "endDate":  moment(this.maxDate).format('YYYY-MM-DD') ,
      "startDate": moment(this.currentDate).format('YYYY-MM-DD')
    }
    if(this.mrnValue !== ''){
      payload['mrn']=this.mrnValue
    }
    if(this.mobileNOValue !== ''){
      payload['customerMobile']=this.mobileNOValue
    }
    if(this.leadStaus !== ''){
      payload['leadStatus']=this.leadStaus
    }
    
    if(this.searchTenantCode !== ''){
      payload['tenantCode']=this.searchTenantCode
      payload['orgCode']=this.searchOrgCode
    }
    this.leadsList=[]
    this.SpinnerService.show()
    this.api.omsCommonMethod(payload).subscribe((res: any) => {
      this.SpinnerService.hide()
      if (res && res.status == '1') {
        this.leadsList = res.data
        this.totalRecords=res.totalRecords
        // this.combinedPlanNames = this.leadsList.map(obj => obj.plans.plan_name).join(', ');
      }
    })

  }

  // getLeadsListFilter() {
  //   let payload = {
  //     "action": "OMS/api/v4/lead/list",
  //     "type": "post",
  //     "actionById": "SDM",
  //     "actionByName": "admin",
  //     "channelCode": "1",
  //     "noOfRecords": 20,
  //     "skip": 0,
  //     // "mrn": "",
  //     // "customerMobile": "",
  //     // "leadStatus": "New",
  //     // "tenantCode": this.selectedTenant ,
  //     // "orgCode": this.selectedOrg 
  //   }
  
  //   this.SpinnerService.show()
  //   this.api.omsCommonMethod(payload).subscribe((res: any) => {
  //     this.SpinnerService.hide()
  //     if (res && res.status == '1') {
  //       this.leadsList = res.data
  //       // this.combinedPlanNames = this.leadsList.map(obj => obj.plans.plan_name).join(', ');
  //     }
  //   })

  // }
filterClear(){
  this.mrnValue='';
  this.mobileNOValue=''
  this.serchBy='mobile'
  this.leadStaus=''
  this.currentDate.setDate(new Date().getDate()-15);
  this.maxDate.setDate(new Date().getDate() + 1);
  this.bsRangeValue = [this.currentDate, this.maxDate];
  this.searchTenantCode ='';
  this.searchOrgCode  ='';
  // this.resetTeantFilters()
  this.getLeadsList()
  if (this.tenantSelect) {
    this.tenantSelect.clearModel(); // Clear the selection
  }
}

  uploadReports(event: any) {
    
    this.reportuploadedFile = "";
    this.documentId = "";
    if (event.target.files.length > 0) {
      this.reportuploadedFile = event.target.files[0]

      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(this.reportuploadedFile.type)) {
        this.leadsCraetion_Form.patchValue({
          file:""
        })
        this.discharge_form.patchValue({
          file:""
        })
        this.toastr.error('Only PDF and image files (JPG, JPEG, PNG) are allowed.');
        return;
      }

      let formData: FormData = new FormData();
      formData.append('file', this.reportuploadedFile); 
      formData.append('document', this.reportuploadedFile);
      let cp = 'CP'
      let Prescription = 'dischargeSummary'
      formData.append('applicationName', cp);
      formData.append('documentType', Prescription);
      this.SpinnerService.show()
      this.api.uploadDocument(formData).subscribe((res: any) => {
        this.SpinnerService.hide()
        if (res.status == 'SUCCESS') {
          this.documentId = res.uploaded_document_id;
          this.toastr.success(res.reason);
          this.saveEHRdocuments();
        } else {
          this.toastr.error(res.reason);
          // alert(res.message)

        }
      } ,(err) => {
        // this.error = err;
        
      }
      
      )
    }
  }

  createLeads(){
    let payload={
      "action": "/OMS/api/v4/lead/create",
      "type": "post",
      "actionById": "sdm",
      "actionByName": "admin",
      "mrn": this.selectedCustomerDeatils.customerMRNID,
      "customerName": this.selectedCustomerDeatils.firstName+" "+this.selectedCustomerDeatils.lastName ,
      "customerAge": this.selectedCustomerDeatils.age,
      "customerGender": this.selectedCustomerDeatils.gender,
      "customerMobile": this.selectedCustomerDeatils.mobile,
      "leadStatus": "NEW",
      "channelCode": "1",
      "dischargeSummary": this.documentId,
      "remarks":this.leadsCraetion_Form.value.remarks,
      "tenantCode": this.selectedTenantCode,
      "orgCode": this.selectedOrgCode,
      "isNewCustomer":this.isNewCustomer,
      "businessId":this.leadsCraetion_Form.value.businessName,
      "addressId":"",
      "orderPincode":"",
      "customerEmail":this.selectedCustomerDeatils.email,
      "orgName":this.selectedOrgName
  }
  this.SpinnerService.show()
  this.api.omsCommonMethod(payload).subscribe((res:any)=>{
    this.SpinnerService.hide()
    if(res && res.status == 1 ){
      this.getLeadsList()
      this.toastr.success(res.message)
      this.modalRef.dismiss()
      this.isNewCustomer=0;
    }else{
      this.toastr.error(res.message)
    }
  })
  }

  getTagsWithPackages(){
    let payload={
      "method": "fetchservice/getTagsWithPackages",
      "type": "POST",
      "application": "mdmv3",
      "request": {}
    }
    this.SpinnerService.show()
    this.api.mdmCommonMethod(payload).subscribe((res:any)=>{
      this.SpinnerService.hide()
      if(res.status == 'success'){
        this.ListTagsWithPackages=res.data
      }
    })
  }

  onTagSecetion(event:any){
    // let array = []
    // event.forEach((res: any) => {
    //   array.push(res.organizationCode)
    // })
    // this.selectedOrg = array
    this.packageByTag(event.Name)
    
  }
  packageByTag(tag:any){
    let payload={
      
        "method": "fetchservice/packageByTag",
        "type": "POST",
        "application": "mdmv3",
        "request": {
            "tag": tag,
            "page_size": 20,
            "offset": 0,
            "status": "2",
            "tenant_code": this.selectedLeadDetails.tenantCode,
            "org_code": this.selectedLeadDetails.orgCode
        }
    
    }
    this.SpinnerService.show()
    this.api.mdmCommonMethod(payload).subscribe((res:any)=>{
      this.SpinnerService.hide()
      if(res.status == 'success'){
        this.listOfPackages=res.data[0]
      }
    })
  }
  onPackageSelect(event:any){
    this.selectedPackages=[]
    let data={
      "plan_code":event.package_code,
       "plan_name":event.package_name,
        "bid":event.package_primary_business,
        "amount":event.package_price
    }
    this.selectedPackages.push(data)
  }

  deletePackages(index:any){
    this.selectedPackages.splice(index, 1);
    console.log(this.selectedPackages)
  }
  deleteOrderPackages(index:any){
    this.selectedPackagesForOrders.splice(index, 1);
    console.log(this.selectedPackagesForOrders)
  }

  updateLeads(type:any){

    let payload={}
    if(type == 'update'){
      
      if(this.selectedPackages.length == 0){
        this.toastr.error("please select package");
        return true;
      }
        payload={
            "action": "/OMS/api/v4/lead/update",
            "type": "post",
            "actionById": "sdm",
            "actionByName": "admin",
            "leadStatus": "INPROGRESS",
            "channelCode": "1",
            "leadId": this.selectedLeadDetails.leadId,
            "customerName": this.selectedLeadDetails.customerName,
            "customerMobile": this.selectedLeadDetails.customerMobile,
            "plans":this.selectedPackages
        }
    }else if(type == 'complete'){
      payload={
        "action": "/OMS/api/v4/lead/update",
        "type": "post",
        "actionById": "sdm",
        "actionByName": "admin",
        "leadStatus": "COMPLETED",
        "channelCode": "1",
        "leadId": this.selectedLeadDetails.leadId,
        "customerName": this.selectedLeadDetails.customerName,
        "customerMobile": this.selectedLeadDetails.customerMobile,
     }
    }else if(type == 'dischargeSummary'){
      payload={
        "action": "/OMS/api/v4/lead/update",
        "type": "post",
        "actionById": "sdm",
        "actionByName": "admin",
        "leadStatus": this.selectedLeadDetails.leadStatus,
        "channelCode": "1",
        "leadId": this.selectedLeadDetails.leadId,
        "customerName": this.selectedLeadDetails.customerName,
        "customerMobile": this.selectedLeadDetails.customerMobile,
        "dischargeSummary": this.documentId
     }
    }
  
  this.SpinnerService.show()
  this.api.omsCommonMethod(payload).subscribe((res:any)=>{
    this.SpinnerService.hide()
    if(res && res.status == 1){
      this.toastr.success(res.message);
      this.getLeadsList()
      this.modalRef.dismiss()
    }

  })
  }
  processOrder(){
    console.log(this.selectedAddressDetails)
     
    if(this.selectedAddressDetails.customerAddrID == undefined || this.selectedAddressDetails.customerAddrID == null || this.selectedAddressDetails.customerAddrID == ''){
      this.ordersErrorMessages='Please provide your address to complete your order.'
      return;
    }
    console.log(this.selectedCustomerDeatils)
    let plansList=[]
    this.selectedPackagesForOrders.map((data:any)=>{
      let object={
          "orderDateTime": moment().add(10,'minute').format('YYYY-MM-DD HH:mm:ss'),
          "mrn": this.selectedLeadDetails.mrn+"",
          "zipcode": this.selectedAddressDetails.zipcode+"",
          "orderBusiness": data.bid+"",
          "AddressId": this.selectedAddressDetails.customerAddrID+"",
          "associate_id": "",
          "slot_transaction_id": "1234567890",
          "associate_branch_id": "",
          "mode_of_service": "1",
          "orderCode": data.plan_code,
          "creation_type": 1, 
          "invoiceto": 1, 
          "reportto": 1,
          "ordersLevelbussinessObject": {
            "leadId": this.selectedLeadDetails.leadId,
        }
      }
      if(this.selectedLeadDetails.dischargeSummary !== null && this.selectedLeadDetails.dischargeSummary !== '' ){
        object['documents']=[
          {
              "documentId": this.selectedLeadDetails.dischargeSummary,
              "documentType": "dischargeSummary",
              "uploadedFrom": "SDM",
              "documentName":""
          }
        ]
      }
      plansList.push(object)
    })
    let payload={
        "mrn": this.selectedLeadDetails.mrn+"",
        "orgCode": this.selectedLeadDetails.orgCode+"",
        "tenantCode": this.selectedLeadDetails.tenantCode+"",
        "services": plansList,
        // "auth_code": "",
        // "user_paid_tx": 0,
        "channel": 4,
        "created_by_id": "CHAdmin",
        "payment_info": {
          "payment_amount": 0,
          "payment_mode": 4,
          "useWallet": false
      }
        // "phlebo_charges": null,
    }
     this.SpinnerService.show()
    this.api.processOrder(payload).subscribe((res:any)=>{
     this.SpinnerService.hide()
     if(res && res.status ==1){
        this.updateLeads('complete')
     }

    })
  }

  downloadReports(id:any){
    let payload={
      document_id:id
    }
    this.api.downloadReports(payload).subscribe((res:any)=>{
      if(res&& res.status == "SUCCESS" ){
        window.open(res.document_downloadLink);
        this.toastr.success(res.reason);
      }else{
        this.toastr.error(res.reason);
      }

    })
  }

  OnlyNumeric(evt: { key: string; }): any {
    if (!/^\d+$/.test(evt.key)) {
      return false;
    }
  }
  saveEHRdocuments(){
    let payload={
      "reportName":"dischargeSummary",
      "reportDate": moment().format('YYYY-MM-DD'),
      "centerName":"",
      "fileType":"dischargeSummary",
      "fileName":this.reportuploadedFile.name,
      "byCallHealth":1,
      "mrn":this.selectedCustomerDeatils.customerMRNID,
      "mimeType":this.reportuploadedFile.type,
      "uploadDocumentId":this.documentId+""
    }
    this.api.saveEHRdocuments(payload).subscribe((res:any)=>{
      if(res && res.status==1){

      }
    })
  }

  
orderActivationEvent(data:any){
  let payload={
    "action": "/OMS/api/v4/confirm/package/eventTrigger",
    "type": "post",
    "orderId": data
 }


this.SpinnerService.show()
this.api.omsCommonMethod(payload).subscribe((res:any)=>{
this.SpinnerService.hide()
if(res ){
  this.toastr.success(res.message)
  // this.getLeadsList()
  // this.modalRef.dismiss()
}else{
  this.toastr.error("some error occurred");
}
})
}
  
}
